import { render, staticRenderFns } from "./InstrucaoBaseHistorica.vue?vue&type=template&id=4defc0b2&scoped=true"
import script from "./InstrucaoBaseHistorica.vue?vue&type=script&setup=true&lang=js"
export * from "./InstrucaoBaseHistorica.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstrucaoBaseHistorica.vue?vue&type=style&index=0&id=4defc0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defc0b2",
  null
  
)

export default component.exports